import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import Index from '@/page/index'
import RedeemCenter from '@/page/RedeemCenter'
import paiwei from '@/page/paiwei'
import waitRobot from '@/page/waitRobot'
import pk from '@/page/pk'
import robot from '@/page/robot'
import single from '@/page/single'

import Language from '@/page/language'
import Faq from '@/page/faq'
import MyAccount from '@/page/myAccount'
import TermsAndCondition from '@/page/termsAndCondition'
import Login from '@/page/Login'
import otp from '@/page/otp'
import land from '@/page/land'
import Invitation from '@/page/invitation'
import Errors from '@/page/errors'

import rankList from '@/page/rankList'
import redeemList from '@/page/redeemList'
import Faq2 from '@/page/faq2'
import TermsAndCondition2 from '@/page/termsAndCondition2'


import test from '@/page/test'
import testMusic from '@/page/testMusic'

Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: ''
		},
      beforeEnter: async (to, from, next) => {
        //路由守卫逻辑
        //路由带号码 直接登录
        if (to.query.mobile) {
          const res = await axios.post('https://demo-battle-api.goquizgo.com/api/user/fast_login', {
            mobile: to.query.mobile
          })
          if (res.data.code === 1){
            localStorage.setItem('token', res.data.data.userinfo.token)
            localStorage.setItem('mobile',res.data.data.userinfo.mobile)
          }
        }
        next()
      }
    },{
      path: '/RedeemCenter',
      name: 'RedeemCenter',
      component: RedeemCenter,
      meta: {
        title: 'RedeemCenter'
      }
    },{
      path: '/paiwei',
      name: 'paiwei',
      component: paiwei,
      meta: {
        title: 'paiwei'
      }
    },{
      path: '/waitRobot',
      name: 'waitRobot',
      component: waitRobot,
      meta: {
        title: 'waitRobot'
      }
    },{
      path: '/pk',
      name: 'pk',
      component: pk,
      meta: {
        title: 'pk'
      }
    },{
      path: '/robot',
      name: 'robot',
      component: robot,
      meta: {
        title: 'robot'
      }
    },{
      path: '/single',
      name: 'single',
      component: single,
      meta: {
        title: 'single'
      }
    },{
      path: '/rankList',
      name: 'rankList',
      component: rankList,
      meta: {
        title: 'rankList'
      }
    },{
      path: '/redeemList',
      name: 'redeemList',
      component: redeemList,
      meta: {
        title: 'redeemList'
      }
    },
    {
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },
    {
		path: '/otp',
		name: 'otp',
		component: otp,
		meta: {
			title: 'otp'
		}
    },
    {
		path: '/land',
		name: 'land',
		component: land,
		meta: {
			title: 'land'
		}
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: Invitation,
      meta: {
        title: 'Invitation'
      }
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: MyAccount,
		meta: {
			title: ''
		}
    },{
		path: '/faq',
		name: 'faq',
		component: Faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: TermsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },
    {
      path: '/language',
      name: 'language',
      component: Language,
      meta: {
        title: 'language'
      }
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
      meta: {
        title: 'errors'
      }
    },{
      path: '/faq2',
      name: 'faq',
      component: Faq2,
      meta: {
        title: 'faqs'
      }
    },
    {
      path: '/termsAndCondition2',
      name: 'termsAndCondition',
      component: TermsAndCondition2,
      meta: {
        title: 'Terms and Condition'
      }
    },

    {
      path: '/test',
      name: 'test',
      component: test,
      meta: {
        title: 'test'
      }
    },
    {
      path: '/testMusic',
      name: 'testMusic',
      component: testMusic,
      meta: {
        title: 'testMusic'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js